export const GET_REPORT_COURIERS = Symbol('GET_REPORT_COURIERS');
export const GET_REPORT_COURIERS_REQUEST = Symbol('GET_REPORT_COURIERS_REQUEST');
export const GET_REPORT_COURIERS_SUCCESS = Symbol('GET_REPORT_COURIERS_SUCCESS');
export const GET_REPORT_COURIERS_ERROR = Symbol('GET_REPORT_COURIERS_ERROR');

